import Entity from "_framework/entities/entity";
import AHDate from "_shared/dates/date";
import EmailAddress from "_shared/email-addresses/email-address";
import Guid from "_shared/guids/guid";
import PendingUserEntityMemberInvitationSchema, {
  PendingUserEntityMemberInvitationJSON,
  PendingUserEntityMemberInvitationParams,
} from "legal-entities/invitations/member-invitations/email-based/pending/_schema/pending-user-entity-member-invitation-schema";

// TODO: Server-side PendingUserEntityMemberInvitation class does not exist.
export default class PendingUserEntityMemberInvitation extends Entity<
  PendingUserEntityMemberInvitation,
  PendingUserEntityMemberInvitationJSON,
  PendingUserEntityMemberInvitationParams
> {
  public static create(values: PendingUserEntityMemberInvitationParams): PendingUserEntityMemberInvitation {
    const parsed = PendingUserEntityMemberInvitationSchema.validate(values);
    return new PendingUserEntityMemberInvitation(parsed);
  }

  public static fromJSON(json: PendingUserEntityMemberInvitationJSON): PendingUserEntityMemberInvitation {
    const params = PendingUserEntityMemberInvitationSchema.deserialize(json);
    return new PendingUserEntityMemberInvitation(params);
  }

  public static fromJSONArray(jsonArray: PendingUserEntityMemberInvitationJSON[]): PendingUserEntityMemberInvitation[] {
    return jsonArray.map((json) => PendingUserEntityMemberInvitation.fromJSON(json));
  }

  public readonly id: Guid;
  public readonly userId: Guid;
  public readonly userEmail: EmailAddress;
  public readonly entityId: Guid;
  public readonly entityName: string;
  public readonly expires: AHDate;
  public readonly createClientRep: boolean;
  public readonly createVendorRep: boolean;
  public readonly isAdmin: boolean;

  public constructor(params: PendingUserEntityMemberInvitationParams) {
    super(params);
    this.id = params.id;
    this.userId = params.userId;
    this.userEmail = params.email;
    this.entityId = params.legalEntityId;
    this.entityName = params.companyName;
    this.expires = params.expires;
    this.createClientRep = params.createClientRep;
    this.createVendorRep = params.createVendorRep;
    this.isAdmin = params.isAdmin;
  }

  public toJSON(): PendingUserEntityMemberInvitationJSON {
    return PendingUserEntityMemberInvitationSchema.serialize({
      ...this,
      email: this.userEmail,
      legalEntityId: this.entityId,
      companyName: this.entityName,
    });
  }

  public valueOf(): PendingUserEntityMemberInvitationJSON {
    return this.toJSON();
  }

  public isEqualTo(other: PendingUserEntityMemberInvitation | null | undefined): boolean {
    return this.id.isEqualTo(other?.id);
  }

  public toString(): string {
    return `PendingUserEntityMemberInvitation {
      id: ${this.id.value},
      userId: ${this.userId.value},
      userEmail: ${this.userEmail.value},
      entityId: ${this.entityId.value},
      entityName: ${this.entityName},
      expires: ${this.expires.toISOString()},
      createClientRep: ${this.createClientRep},
      createVendorRep: ${this.createVendorRep},
      isAdmin: ${this.isAdmin}
    }`;
  }
}
